<template lang="pug">
#app
  router-view
  //- Home
</template>

<script>
import Home from '@/pages/home'
export default {
  name: 'App'
  , components: { Home }
}
</script>

<style lang="sass" scoped>
// #app
//   position: fixed
//   top: 0
//   left: 0
//   right: 0
//   bottom: 0
</style>
